export default [{
  value: 'male',
  text: 'Masculino'
}, {
  value: 'female',
  text: 'Femenino'
}]



// WEBPACK FOOTER //
// ./src/data/genders.js